export default {
  routerPaths: [
    {
      path: '/is-assetmgmt/assets',
      name: 'ISAssetMgmtList',
      view: 'is/assetMgmt/list',
      meta: {
        isDrawerIconLink: true,
        i18n: 'IS.AssetMgmt.drawer.isAssetMgmtList',
        permissions: { subject: 'IsAssetMgmt', action: 'read' },
      },
    },
    {
      path: '/is-assetmgmt/assets/:id',
      name: 'ISAssetMgmtDetails',
      view: 'is/assetMgmt/details',
      meta: {
        permissions: { subject: 'IsAssetMgmt', action: 'read' },
        i18n: 'IS.AssetMgmt.drawer.isAssetMgmtList',
      },
    },
    {
      path: '/is-assetmgmt/zones',
      name: 'ISAssetMgmtZones',
      view: 'is/assetMgmt/zones',
      meta: {
        isDrawerIconLink: true,
        i18n: 'IS.AssetMgmt.drawer.isAssetMgmtZones',
        permissions: { subject: 'IsAssetMgmt', action: 'read' },
      },
    },
    {
      path: '/is-assetmgmt/map',
      name: 'ISAssetMgmtMap',
      view: 'is/assetMgmt/map',
      meta: {
        isDrawerIconLink: true,
        i18n: 'IS.AssetMgmt.drawer.isAssetMgmtMap',
        permissions: { subject: 'IsAssetMgmt', action: 'read' },
      },
    },
  ],
  drawerLinks: [
    {
      icon: 'fal fa-search-location',
      text: 'IS.AssetMgmt.drawer.isAssetMgmt',
      children: [
        {
          to: '/is-assetmgmt/assets',
          icon: 'fal fa-list-ul',
          text: 'IS.AssetMgmt.drawer.isAssetMgmtList',
        },
        {
          to: '/is-assetmgmt/zones',
          icon: 'fal fa-draw-polygon',
          text: 'IS.AssetMgmt.drawer.isAssetMgmtZones',
        },
        {
          to: '/is-assetmgmt/map',
          icon: 'fal fa-map-marked-alt',
          text: 'IS.AssetMgmt.drawer.isAssetMgmtMap',
        },
        // {
        //   to: '/digitaltwin-mgmt',
        //   icon: 'fal fa-satellite-dish',
        //   text: 'IS.AssetMgmt.drawer.isAssetMgmtTracker',
        // },
      ],
    },
  ],
};
